<template>
  <h2>Loading...</h2>
</template>

<script>
import { mapActions } from 'vuex'
import { config } from '../config'

export default {
  name: 'OAuth',
  async created() {
    const redirect = this.$cookies.get(config.redirectCookie)
    this.$cookies.remove(config.redirectCookie)
    if (redirect) {
      this.login({ route: { path: redirect } })
    } else {
      this.login({
        route: { name: 'gateways' },
      })
    }
  },
  methods: {
    ...mapActions('user', ['login']),
  },
}
</script>
